function open (event) {
	event.preventDefault();

	// Enable nav, open
	nav.addClass('is-enabled');
	wrapper.addClass('is-open');

	// Focus menu
	setTimeout(function () {
		wrapper.addClass('is-opened');
		menu.focus();
	}, 600);
}

function close (event) {
	event.preventDefault();

	// Close nav
	wrapper.removeClass('is-open');
	wrapper.removeClass('is-opened');

	// Disable, focus article
	setTimeout(function () {
		nav.removeClass('is-enabled');
		article.focus();
	}, 600);
}

var wrapper = $('#wrapper');
var article = $('#article');
var nav = $('#nav');

// First menu within nav
var menu = nav.find('ul').first();

// Allow focus
article.attr('tabindex', '-1');
menu.attr('tabindex', '-1');

// Listen for events
wrapper.on('click', '.menu--open', open);
wrapper.on('click', '.menu--close', close);



//////////////////
// WEBPACK FOOTER
// ./src/httpdocs/root/static/js/modules/menu.js
// module id = 6
// module chunks = 0